import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const icon =
    theme === "dark" ? (
      <Moon className="w-5 h-5" strokeWidth={1.5} />
    ) : theme === "light" ? (
      <Sun className="w-5 h-5" strokeWidth={1.5} />
    ) : (
      <Monitor className="w-5 h-5" strokeWidth={1.5} />
    );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="grid place-items-center w-11 h-11 rounded-md text-zinc-500 hover:text-brand hover:bg-brand-50 dark:text-zinc-400 dark:hover:text-brand-200 dark:hover:bg-zinc-800 transition-colors"
          aria-label="Toggle colour theme"
        >
          {icon}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-36">
        <DropdownMenuItem onClick={() => setTheme("light")} className="cursor-pointer gap-2">
          <Sun className="w-4 h-4" strokeWidth={1.5} /> Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")} className="cursor-pointer gap-2">
          <Moon className="w-4 h-4" strokeWidth={1.5} /> Dark
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")} className="cursor-pointer gap-2">
          <Monitor className="w-4 h-4" strokeWidth={1.5} /> System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
